import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "info",
  "use": "info-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 21\" id=\"info\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 .5C4.48.5 0 4.98 0 10.5s4.48 10 10 10 10-4.48 10-10-4.48-10-10-10Zm-1 5v2h2v-2H9Zm0 4v6h2v-6H9Zm-7 1c0 4.41 3.59 8 8 8s8-3.59 8-8-3.59-8-8-8-8 3.59-8 8Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol